var countries = {
    "AT": "Austria",
    "BE": "Belgium",
    "CH": "Switzerland",
    "DE": "Germany",
    "DK": "Denmark",
    "ES": "Spain",
    "FR": "France",
    "GB": "United Kingdom",
    "IT": "Italy",
    "LUX": "Luxembourg",
    "PL": "Poland",
    "SE": "Sweden",
    "SK": "Slovakia",
    "SVN": "Slovenia",
    "HU": "Hungary",
    "CZ": "Czechia"
}

